import React from "react";

import useOutputReportStore from "../../../store/OutputReport.store";
import {
  definitions,
  equityDefinitions,
} from "../../../utils/resources/definitionsCopy";
import { equityDisclosuresCopy } from "../../../utils/resources/disclosuresCopy";

import ChangePageButtons from "../../../components/ChangePageButtons";
import Definitions from "../../../components/Definitions";
import Disclosures from "../../../components/Disclosures";
import AttributionTrackingErrorReport from "../../../components/Reports/AttributionTrackingErrorReport";
import CoverPage from "../../../components/Reports/CoverPage";
import OneSheeterReport from "../../../components/Reports/OneSheeterReport";
import PortfolioCharacteristicsReport from "../../../components/Reports/PortfolioCharacteristicsReport";
import ProposedSellsReport from "../../../components/Reports/ProposedSellsReport";
import Sectors from "../../../components/Reports/SectorsReport";
import StyleRiskExposureReport from "../../../components/Reports/StyleRiskExposureReport";
import TransitionSummaryReport from "../../../components/Reports/TransitionSummaryReport";

const TransitionEquityReport = () => {
  const data = useOutputReportStore((state) => state.data);
  const types = useOutputReportStore((state) => state.types);

  const disclosuresArgs = {
    heading: "Disclosures",
    className: "report-article",
    bodyContent: [
      {
        heading: "Marketing Communication",
        content: equityDisclosuresCopy.report.body,
      },
    ],
    footnote: equityDisclosuresCopy.report.footnote,
  };

  const definitionsArgs = {
    className: "report-article",
    bodyContent: [
      {
        heading: definitions.headings.explanation,
        cardContent: [
          definitions.taxLiability,
          definitions.balance,
          definitions.minTrackingError,
        ],
        gridContent: [
          definitions.currentPortfolio,
          definitions.benchmark.transition,
          definitions.referenceIndex.equity,
        ],
        note: equityDefinitions.note,
      },
      {
        listContent: [
          {
            heading: definitions.headings.generalDefinitions,
            content: [
              equityDefinitions.costBasis,
              equityDefinitions.stTaxRates,
              equityDefinitions.ltTaxRates,
              equityDefinitions.realizedStGains,
              equityDefinitions.realizedLtGains,
              equityDefinitions.averageMarketCap,
              equityDefinitions.betaToBenchmark,
              equityDefinitions.commonFactorRisk,
              equityDefinitions.country,
              equityDefinitions.defensive,
              equityDefinitions.dividend,
              equityDefinitions.gics,
              equityDefinitions.caps,
              equityDefinitions.sectorRisk,
              equityDefinitions.specificRisk,
              equityDefinitions.styleRisk,
              equityDefinitions.trackingErrorBenchmark,
              equityDefinitions.totalRisk,
            ],
          },
          {
            heading: definitions.headings.styleRiskDefinitions,
            content: [
              equityDefinitions.usBeta,
              equityDefinitions.usDividendYield,
              equityDefinitions.usEarningsQuality,
              equityDefinitions.usEarningsYield,
              equityDefinitions.usEarningsVariability,
              equityDefinitions.usGrowth,
              equityDefinitions.usLiquidity,
              equityDefinitions.usLeverage,
              equityDefinitions.usLongTermReversal,
              equityDefinitions.usManagementQuality,
              equityDefinitions.usMidCapitalization,
              equityDefinitions.usMomentum,
              equityDefinitions.usProfitability,
              equityDefinitions.usProspect,
              equityDefinitions.usResidualVolatility,
              equityDefinitions.usSize,
              equityDefinitions.usValue,
            ],
          },
          {
            heading: definitions.headings.indexDescriptions,
            content: [
              equityDefinitions.russellIndex,
              equityDefinitions.russellGrowthIndex,
              equityDefinitions.russellValueIndex,
            ],
          },
        ],
      },
    ],
    footnote: equityDefinitions.footnote,
  };

  return (
    <>
      <CoverPage />
      {data && types && (
        <>
          <OneSheeterReport />
          <TransitionSummaryReport />
          <PortfolioCharacteristicsReport />
          <AttributionTrackingErrorReport />
          <Sectors reportName={"Sectors (GICS)"} type="gics" />
          <Sectors reportName={"Sectors (Risk Exposure)"} type="risk" />
          <StyleRiskExposureReport />
          <ProposedSellsReport />
          <Definitions {...definitionsArgs} />
          <Disclosures {...disclosuresArgs} />
        </>
      )}
      <ChangePageButtons />
    </>
  );
};

export default TransitionEquityReport;
